(function(){
if(window.__wvMainCart){return}
window.__wvMainCart=1;
document.addEventListener('submit',function(e){
 var f=e.target;
 if(!f||!f.matches||!f.matches('form[action*="/cart/add"]')){return}
 if(f.closest('#wvAddons')){return}
 var d=document.querySelector('cart-drawer');
 if(!d||typeof d.renderContents!=='function'||typeof d.getSectionsToRender!=='function'){return}
 var pf=f.closest('product-form');
 if(pf&&typeof pf.onSubmitHandler==='function'&&pf.cart){return}
 e.preventDefault();e.stopImmediatePropagation();
 var btn=f.querySelector('[type="submit"]');
 if(btn&&btn.getAttribute('aria-disabled')==='true'){return}
 if(btn){btn.setAttribute('aria-disabled','true');btn.classList.add('loading');var sp=btn.querySelector('.loading-overlay__spinner');if(sp){sp.classList.remove('hidden')}}
 var fd=new FormData(f);
 fd.append('sections',d.getSectionsToRender().map(function(s){return s.id}).join(','));
 fd.append('sections_url',window.location.pathname);
 if(d.setActiveElement){d.setActiveElement(document.activeElement)}
 fetch('/cart/add.js',{method:'POST',headers:{'X-Requested-With':'XMLHttpRequest','Accept':'application/javascript'},body:fd}).then(function(r){return r.json()}).then(function(j){
  var w=f.querySelector('.pform-error-wrap'),m=f.querySelector('.pform-error-msg');
  if(j.status){if(w&&m){m.textContent=j.description||j.message||'';w.removeAttribute('hidden')}return}
  if(w){w.setAttribute('hidden','')}
  d.renderContents(j);if(window.freeShippMsg){window.freeShippMsg()}
 }).catch(function(){window.location.href='/cart'}).finally(function(){
  if(btn){btn.removeAttribute('aria-disabled');btn.classList.remove('loading');var s2=btn.querySelector('.loading-overlay__spinner');if(s2){s2.classList.add('hidden')}}
 });
},true);
function bump(){var els=document.querySelectorAll('.product-form__submit .txt');for(var i=0;i<els.length;i++){var el=els[i];el.style.fontSize='';var fs=parseFloat(window.getComputedStyle(el).fontSize);if(fs){el.style.fontSize=(fs+2)+'px'}}}
if(document.readyState!=='loading'){bump()}else{document.addEventListener('DOMContentLoaded',bump)}
var rt;window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(bump,200)});
})();
